
import axios from 'axios';
import authHeader from './auth-header'; // Asegúrate de que esto esté configurado

const API_URL = process.env.VUE_APP_API_BASE_URL;

export default {
    getCards() {
        const url = `${API_URL}/analytics/cards`; // Si pageUrl es null, usa la URL base
        return axios.get(url, { headers: authHeader() });
    },
    getSellerCards(sellerId) {
        const url = `${API_URL}/analytics/seller-cards?seller_id=${sellerId}`;
        return axios.get(url, { headers: authHeader() });
    },
    getYear() {
        const url = `${API_URL}/analytics/year`; // Si pageUrl es null, usa la URL base
        return axios.get(url, { headers: authHeader() });
    },
    getUndelivered() {
        const url = `${API_URL}/analytics/undelivered`; // Si pageUrl es null, usa la URL base
        return axios.get(url, { headers: authHeader() });
    },
    getUnvalidate() {
        const url = `${API_URL}/analytics/unvalidated`; // Si pageUrl es null, usa la URL base
        return axios.get(url, { headers: authHeader() });
    },
    getProduction() {
        const url = `${API_URL}/analytics/production`; // Si pageUrl es null, usa la URL base
        return axios.get(url, { headers: authHeader() });
    },
    getProductionFinish() {
        const url = `${API_URL}/analytics/production?status=2`; // Si pageUrl es null, usa la URL base
        return axios.get(url, { headers: authHeader() });
    },
    getReportProductionUser(data) {
        return axios.post(`${API_URL}/export/production-user`, data, { 
            headers: {
                ...authHeader(), 
                'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            },
            responseType: 'blob', 
        });
    }    
    
};